import React from 'react';
import successPicture from '../images/cat-happy.png';
import errorPicture from '../images/cat-sad.png';

export default function InfoToolTip({ toolTipPicture, isOpen, onClose, title}) {

  return (
    <div className={`popup ${isOpen ? "popup_opened" : ""}`}>
      <div className='popup__tooltip-container' >
        <div className='popup__text-centered'>
          {toolTipPicture === 'success' && (<img src={successPicture} width='120px' alt='Success' />)}
          {toolTipPicture === 'error' && (<img src={errorPicture} width='120px' alt='Error' />)}
        </div>
        <h2 className='popup__tooltip-title'>{title}</h2>
        <button type='button' className='popup__close-btn' onClick={onClose} />
      </div>
    </div>
  )
}